module.exports = __webpack_public_path__ + "img/incident_servicios_publicos.75428bb4.svg";